module.exports = __webpack_public_path__ + "static/media/1.c4e6b900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9027/1.jpg
// module id = 875
// module chunks = 0